export default function ZentraqLogo({
  className = "",
  title = "ZENTRAQ Logo",
  variant = "full",
  theme = "light",
}) {
  const isMarkOnly = variant === "mark";
  const textColor = theme === "dark" ? "#FFFFFF" : "#0B1F2A";
  const accentColor = "#00A8A8";
  const ringColor = theme === "dark" ? "#FFFFFF" : "#0B1F2A";

  if (isMarkOnly) {
    return (
      <svg
        className={className}
        role="img"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={title}
        preserveAspectRatio="xMidYMid meet"
      >
        <title>{title}</title>
        <g transform="translate(6,6)">
          <path
            d="M24 4c13.3 0 24 10.7 24 24"
            fill="none"
            stroke={ringColor}
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M48 36c-6 13.1-21.5 18.9-34.6 12.9C.3 42.9-5.5 27.4.5 14.3"
            fill="none"
            stroke={ringColor}
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M4 24h43"
            fill="none"
            stroke={accentColor}
            strokeWidth="5.5"
            strokeLinecap="round"
          />
          <circle cx="24" cy="24" r="5" fill={accentColor} />
          <path
            d="M45 24c0 0-2 10-11 19"
            fill="none"
            stroke={accentColor}
            strokeWidth="6.5"
            strokeLinecap="round"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      className={className}
      role="img"
      viewBox="0 0 520 88"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      preserveAspectRatio="xMinYMid meet"
    >
      <title>{title}</title>

      <g transform="translate(4,6)">
        <path
          d="M24 4c13.3 0 24 10.7 24 24"
          fill="none"
          stroke={ringColor}
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M48 36c-6 13.1-21.5 18.9-34.6 12.9C.3 42.9-5.5 27.4.5 14.3"
          fill="none"
          stroke={ringColor}
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M4 24h43"
          fill="none"
          stroke={accentColor}
          strokeWidth="5.5"
          strokeLinecap="round"
        />
        <circle cx="24" cy="24" r="5" fill={accentColor} />
        <path
          d="M45 24c0 0-2 10-11 19"
          fill="none"
          stroke={accentColor}
          strokeWidth="6.5"
          strokeLinecap="round"
        />
      </g>

      <g transform="translate(74,14)">
        <g fill={textColor}>
          <path d="M0 48 32 12H3V0h46v9L17 45h32v11H0Z" />
          <path d="M66 0h41v11H78v12h22v10H78v14h29v11H66Z" />
          <path d="M122 0h12l31 39V0h11v58h-12l-31-39v39h-11Z" />
          <path d="M198 11h-19V0h50v11h-19v47h-12Z" />
          <path
            d="M241 0h29c16 0 26 8 26 22 0 9-5 16-14 20l15 16h-16l-13-14h-15v14h-12Zm27 33c10 0 16-4 16-11 0-8-6-11-16-11h-15v22Z"
          />
          <path d="M324 0h12l26 58h-13l-5-13h-27l-5 13h-13Zm15 35-9-21-9 21Z" />
        </g>
        <path
          d="M412 59c-4 0-7.9-.5-11.4-1.5l-11.1 11h-15l17.1-17c-9.2-6.1-15-16.4-15-28.6 0-19.2 15.4-33.1 36-33.1 20.4 0 35.8 13.9 35.8 33.1S433 59 412 59Zm0-11.5c12.8 0 22.7-10 22.7-24.5 0-14.1-9.9-24.1-22.7-24.1-13 0-23 10-23 24.1 0 8.1 3.5 14.9 9.6 19.3l12.2-12.2h16.4l-14.7 14.7c-.2 0-.4 0-.5.1Z"
          fill={accentColor}
        />
      </g>
    </svg>
  );
}
